export default __webpack_public_path__ + "static/media/thumb_down.3fdcf1b0.svg";